import { Controller } from '@hotwired/stimulus';
import { FetchRequest } from '@rails/request.js';

export default class extends Controller {
  static values = {
    messageUpdateUrl: String,
  };

  async updateMessage() {
    const request = new FetchRequest('delete', this.messageUpdateUrlValue, { contentType: 'application/json' });

    const response = await request.perform();

    if (response.ok) {
      window.location.assign(this.element.href);
    }
  }
}
